<template>
    <div class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
        <div class="col-span-2 lg:col-span-1">
            <AssetAssignSaleSectionDuplicate
                :asset="asset"
                :sale_section_id="state.current_sale_section_id"
                v-on:sale_section_updated="saleSectionUpdated"
            />
        </div>
        <div class="col-span-2 lg:col-span-1">
            <AssetAssignSaleCodeDuplicate
                :asset="asset"
                :sale_section_id="state.current_sale_section_id"
                :sale_code_id="state.current_sale_code_id"
                :require_sale_section_id="true"
                v-on:sale_code_updated="saleCodeUpdated"
            />
        </div>
    </div>
</template>

<script>
import {onMounted, reactive, watch} from "vue"
import { useSaleStore } from '@sto/sale.store'
import { useAssetStore } from '@sto/asset.store'
import { useSystemStore } from '@sto/system.store'

import AssetAssignSaleSectionDuplicate from "@par/asset/AssetAssignSaleSectionDuplicate.vue"
import AssetAssignSaleCodeDuplicate from "@par/asset/AssetAssignSaleCodeDuplicate.vue"
import {getPayload, isValid} from "@lib/helpers.js";
export default {
    props: ['asset'],
    components: {
        AssetAssignSaleSectionDuplicate,
        AssetAssignSaleCodeDuplicate
    },
    setup(props, {emit}) {

        const SALE_STORE = useSaleStore();
        const ASSET_STORE = useAssetStore();
        const SYSTEM_STORE = useSystemStore();

        const state = reactive({
            current_sale_code_id: null,
            current_sale_section_id: null,
            update_loading: false
        })

        const saleCodeUpdated = sale_code_id => {
            state.current_sale_code_id = sale_code_id
            emit('sale_section_code_updated', {
                sale_section_id: state.current_sale_section_id,
                sale_code_id: state.current_sale_code_id
            })
        }

        const saleSectionUpdated = sale_section_id => {
            state.current_sale_section_id = sale_section_id
        }

        const setFromAsset = () => {
            state.current_sale_code_id = props.asset?.sale_code_id
                ? props.asset?.sale_code_id
                : null
            state.current_sale_section_id = props.asset?.sale_section_id
                ? props.asset?.sale_section_id
                : null
        }

        watch(
            () => props.asset?.id,
            () => {
                setFromAsset()
            }
        )

        onMounted(() => {
            setFromAsset()
        })

        return {
            state,
            saleCodeUpdated,
            saleSectionUpdated
        }
    }
}
</script>